document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.size-chart-btn');

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const block = btn.closest('.size-chart-block');
      const modal = block ? block.nextElementSibling : null;

      if (modal && modal.classList.contains('size-chart-modal')) {
        modal.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.size-chart-modal').forEach(function (modal) {
    const closeBtn = modal.querySelector('.close-size');

    closeBtn.addEventListener('click', function () {
      modal.classList.remove('active');
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });
  });
});